const findActiveCues = (currentTime, cues, prevActiveCues = []) => {
  if (!cues.length) {
    return prevActiveCues
  }

  const activeCues = []

  for (let i = 0, l = cues.length; i < l; ++i) {
    const cue = cues[i]

    if (cue.startTime <= currentTime && cue.endTime >= currentTime) {
      activeCues.push(cue)
    } else if (
      cue.startTime === cue.endTime &&
      cue.startTime <= currentTime &&
      cue.endTime + 0.5 >= currentTime
    ) {
      activeCues.push(cue)
    }
  }

  let changed = false

  if (activeCues.length !== prevActiveCues.length) {
    changed = true
  } else {
    for (let i = 0; i < activeCues.length; ++i) {
      if (prevActiveCues.indexOf(activeCues[i]) === -1) {
        changed = true
        break
      }
    }
  }

  return changed ? activeCues : prevActiveCues
}

export default findActiveCues
